'use client';

import { sendGTMEvent } from './gtm-helper';

export const sendSuperStarEvent = (superStarNameDesc?: {
  mainString: string;
  subString: string;
}) => {
  const name = superStarNameDesc ? superStarNameDesc.mainString : '';
  const desc = superStarNameDesc ? superStarNameDesc.subString : '';

  sendGTMEvent({
    category: 'Superstar Database',
    event: 'superstar_individual_viewed',
    action: `superstar-database/${name} ${desc}/viewed`,
  });
};
